import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { OlaApi } from "../../../services";

// FIXME: does not match the type of expected response
const emptyResponse = {
  data: [],
  isLoading: false,
};

export const useOfflinePurchases = (isEnabled: boolean) => {
  const olaApi = OlaApi.init();
  const { data, isLoading } = useQuery(QUERY_KEYS.offlinePurchases, async () => {
    if (!isEnabled) {
      return Promise.resolve(emptyResponse);
    }
    try {
      return await olaApi.getOfflinePurchases();
    } catch {
      return Promise.resolve(emptyResponse);
    }
  });
  return {
    data,
    isLoading,
  };
};
